import { t } from '@trimble/i18n';
import { getLogger } from '@trimble/logging';
import { Component, createSignal, Show, Switch, Match } from 'solid-js';

type RequestAccessStatus = 'idle' | 'loading' | 'success' | 'error';

export interface RequestAccessBannerProps {
  errorMessage: string;
  onRequestAccess?(): Promise<void>;
}

export const RequestAccessBanner: Component<RequestAccessBannerProps> = (
  props
) => {
  const [requestAccessStatus, setRequestAccessStatus] =
    createSignal<RequestAccessStatus>('idle');

  const handleRequestAccess = async (): Promise<void> => {
    if (!props.onRequestAccess) return;
    setRequestAccessStatus('loading');
    try {
      await props.onRequestAccess();
      setRequestAccessStatus('success');
    } catch (error) {
      getLogger().error('Failed to request Connect project access', error);
      setRequestAccessStatus('error');
    }
  };

  return (
    <div class="px-2 py-1 flex flex-col gap-2">
      <modus-wc-alert
        alert-description={props.errorMessage}
        dismissible={false}
        role="alert"
        variant="error"
      />
      <Show when={props.onRequestAccess}>
        <Switch>
          <Match when={requestAccessStatus() === 'success'}>
            <p class="text-xs text-green-700 px-1">
              {t('measurements.measurementSaveStatus.requestAccessSent')}
            </p>
          </Match>
          <Match when={requestAccessStatus() !== 'success'}>
            <div class="flex flex-col gap-1">
              <Show when={requestAccessStatus() === 'error'}>
                <p class="text-xs text-red-600 px-1">
                  {t('measurements.measurementSaveStatus.requestAccessFailed')}
                </p>
              </Show>
              <modus-button
                color="primary"
                size="small"
                disabled={requestAccessStatus() === 'loading'}
                onClick={handleRequestAccess}
              >
                {requestAccessStatus() === 'loading'
                  ? t('measurements.measurementSaveStatus.requestAccessSending')
                  : t('measurements.measurementSaveStatus.requestAccess')}
              </modus-button>
            </div>
          </Match>
        </Switch>
      </Show>
    </div>
  );
};
